import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { consumeCueSelectedOpenings } from '@/utils/cue-handoff';
import { wxCopilotContextManager } from '@/utils/wx-copilot-context-manager';

export function useWxCopilotPageContext(mountId = 'wx-copilot-root') {
  const location = useLocation();

  useEffect(() => {
    // Openings staged by the freemium wizard before leaving `/post-job`.
    const stagedOpenings = consumeCueSelectedOpenings();
    if (stagedOpenings) {
      wxCopilotContextManager.setOpeningsContext(stagedOpenings);
    }

    const url = `${location.pathname}${location.search}${location.hash}`;
    wxCopilotContextManager.sendPageContext(url, mountId);
  }, [location, mountId]);

  useEffect(() => {
    return () => {
      wxCopilotContextManager.setOpeningsContext(undefined);
    };
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      wxCopilotContextManager.cleanup();
    };
  }, []);
}
